import type { IconProps } from '../types/IconProps.ts';
export const ListTodo: IconProps = {
    name: 'ListTodo',
    children: [
        `<path d="M13 5h8M13 12h8M13 19h8" />`,
        `<rect width="6" height="6" x="3" y="4" rx="1" />`,
        `<path d="m3 18 1.65 1.65c.2.2.5.2.7 0L9 16" />`,
    ]
};